var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeHide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 2,
    fill: "#9DA1B5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 11L3 13",
    stroke: "#9DA1B5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 3L5 11",
    stroke: "#9DA1B5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.98645 12.4885C6.65927 12.6639 7.34393 12.75 8.00005 12.75C10.6855 12.75 13.8489 11.3075 14.722 8.20306L14.7791 8L14.722 7.79694C14.4344 6.77434 13.8983 5.93207 13.2126 5.26228L12.1484 6.32649C12.6231 6.789 12.9952 7.34883 13.2152 8C12.5055 10.1 10.2148 11.25 8.00005 11.25C7.75575 11.25 7.51054 11.236 7.26662 11.2083L5.98645 12.4885ZM8.73347 4.7917C8.48955 4.76399 8.24434 4.75 8.00005 4.75C5.78527 4.75 3.49455 5.89995 2.78485 8C3.00491 8.65117 3.37698 9.211 3.85166 9.67351L2.78745 10.7377C2.10178 10.0679 1.56566 9.22566 1.27806 8.20306L1.22095 8L1.27806 7.79694C2.15119 4.69247 5.31463 3.25 8.00005 3.25C8.65617 3.25 9.34082 3.33611 10.0136 3.51153L8.73347 4.7917Z",
    fill: "#9DA1B5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeHide);
export default __webpack_public_path__ + "static/media/eyeHide.448aff830897c1f0143fc0e99335d7be.svg";
export { ForwardRef as ReactComponent };